import React, { useState, useCallback } from 'react';
import * as PropTypes from 'prop-types';
import { FormGroup } from '@snsw/react-component-library';
// eslint-disable-next-line no-restricted-imports
import { AutoSuggest } from '@snsw/react-component-library/build/Components';
import { SnswBusinessLookupService } from './snsw-business-lookup-service';
import moment from 'moment';
import { debounce } from 'lodash';
import { useApplicationConfig } from '../../store';

const action = name => e => { /* console.debug(name) */};

export const BusinessSearch = props => {
    const appConfig = useApplicationConfig();

    const emptySuggestionList = [{ abn: '', businessName: 'Searching...' }];
    const [suggestions, setSuggestions] = useState(emptySuggestionList);

    const search = value => {
        setSuggestions(emptySuggestionList);
        console.log('searching: ', value);
        if (value && value.length >= 4) {
            getLookupService().checkABR(value)
                .subscribe(results => {
                    console.log('Received abr response', results);
                    setSuggestions(results);
                });
        }
    };

    const debouncedSearch = useCallback(debounce(newValue => search(newValue), 500), []);

    const handleOnChange = (suggestion, value, method) => {
        console.log('on change', suggestion, value, method);
        if (method === 'type') {
            debouncedSearch(value);
        }
    };

    const mapBusinessPropertiesToMatchBusinessProfile = business => ({
        ...business,
        identifier: business?.abn,
        entityName: business?.entityName || business?.businessName,
        entityType: undefined,
        abnEntityType: business?.entityType,
        abnLocation: {
            stateCode: business?.mainBusinessAddressState,
            postCode: business?.mainBusinessAddressPostCode
        },
        abnGstStatus: {
            status: business?.gstRegistrationStatus ? `Registered since ${moment(business?.gstRegistrationFrom).format('YYYY-MM-DD')}` : 'Not registered for GST',
            effectiveFrom: business?.gstRegistrationFrom
        },
        abnEntityStatus: {
            statusCode: business?.abnEntityStatusCode,
            effectiveFrom: moment(business?.abnEffectiveFrom).format('YYYY-MM-DD'),
        }
        ,
        abnSuppressed: business?.businessName === '' && business?.entityName === '' &&
            business?.entityType === '' && business?.mainBusinessAddressPostCode === undefined
    });

    const getLookupService = () => new SnswBusinessLookupService(appConfig);
    const onSelectBusiness = business => {
        const selectedBusinessName = business.businessName;
        console.log('selected business', selectedBusinessName, business);
        if (business.abnEntityStatusCode) {
            props.onSelect(mapBusinessPropertiesToMatchBusinessProfile(business));
        } else {
            // we have searched by name, so now we need to do another
            // search by ABN to get all the required attributes
            getLookupService().checkABR(business.abn)
                .subscribe(results => {
                    const convertedBusiness = mapBusinessPropertiesToMatchBusinessProfile(results[0]);
                    // so we retain the original matched and search for business name and
                    // the entity name will be the main name for the ABN.
                    convertedBusiness.businessName = selectedBusinessName;
                    props.onSelect(mapBusinessPropertiesToMatchBusinessProfile(convertedBusiness));
                });
        }
    };

    return (<FormGroup
        id={ `${props.name}-group` }
        label={ props.label || 'Business name, ABN or ACN' }
        helpMessage={ props.helpMessage || 'Enter your business name, 9 digit ACN or 11 digit ABN' }
        errorMessage={ props.errorMessage }
        hasError={ props.hasError }
    >
        <AutoSuggest
            className='business-search-auto-suggest'
            placeholder={ props.placeholder || 'Start typing to search business' }
            id={ props.name }
            name={ props.name }
            initialValue={ props.initialValue }
            minSearchChars={ 5 }
            getCustomSuggestion={ function getSuggestionValue(suggestion) {
                return `${suggestion?.businessName} (ABN ${suggestion?.abn})`;
            } }
            onClearSuggestions={ action('onClearSuggestions is called') }
            onChange={ handleOnChange }
            onSelect={ onSelectBusiness }
            onBlur={ action('blur') }
            onValueChange={ props.onValueChange }
            renderCustomSuggestion={ function renderSuggestion(suggestion) {
                return suggestion?.businessName + (suggestion.abn ? ` (ABN ${suggestion?.abn})` : '');
            } }
            //shouldRenderSuggestions={action("should render suggestions")}
            suggestions={ suggestions }
        />
        {}
    </FormGroup>);
};

BusinessSearch.propTypes = {
    name: PropTypes.string.isRequired,
    onSelect: PropTypes.func.isRequired,
    onValueChange: PropTypes.func.isRequired,
    placeholder: PropTypes.string,
    errorMessage: PropTypes.string,
    label: PropTypes.oneOfType([ PropTypes.string, PropTypes.object ]),
    helpMessage: PropTypes.string,
    initialValue: PropTypes.string,
    hasError: PropTypes.bool,
};
